/**
 * Stammdaten der Hersteller. OrderCity pflegt sie im Dashboard; sie bleiben
 * intern und gehen nicht an Mandanten.
 */
/** Feste Produktkategorien – dieselben Namen wie im ERP (Seed `produktkategorien`). */
export const PRODUKTKATEGORIEN = [
    "Plissee",
    "Wabenplissee (Duette)",
    "Rollo",
    "Doppelrollo (Duo)",
    "Rollladen",
    "Alu-Jalousie",
    "Holzjalousie",
    "Lamellenvorhang (vertikal)",
    "Flächenvorhang",
    "Raffrollo",
    "Markise",
    "Insektenschutz",
    "Gardinenschiene",
    "Vorhang / Gardine",
    "Nähen",
    "Sonstiges",
];
/** In welcher Form ein Hersteller seine Preise liefert – Preisliste (PDF) oder API. */
export const PREISARTEN = ["ek_netto", "vk_netto", "vk_brutto"];
export const PREISART_TEXT = {
    ek_netto: "EK netto",
    vk_netto: "VK netto",
    vk_brutto: "VK brutto (UVP)",
};
/** Höchster Rabatt des Herstellers in Prozent – 100 % ergäbe einen EK von 0 €. */
export const RABATT_MAX = 99.99;
/**
 * „VK brutto (UVP) · 50 % Rabatt“ – kommt der Rabatt je Artikel vom Hersteller: „EK netto · Rabatt dynamisch“;
 * mit Teuerungszuschlag zusätzlich „· 5 % Teuerung“.
 */
export function konditionText(preisart, rabattProzent, dynamisch = false, teuerungProzent = 0) {
    const rabatt = dynamisch ? "Rabatt dynamisch" : `${rabattProzent.toLocaleString("de-DE")} % Rabatt`;
    const teuerung = teuerungProzent > 0 ? ` · ${teuerungProzent.toLocaleString("de-DE")} % Teuerung` : "";
    return `${PREISART_TEXT[preisart]} · ${rabatt}${teuerung}`;
}
/**
 * Marge der Filiale in % der Hersteller-UVP inkl. Teuerungszuschlag – so wie die Preiskette rechnet:
 * Hersteller-EK = Liste × (1 + Teuerung) × (1 − Rabatt), EK der Filiale = Hersteller-EK × (1 + Aufschlag).
 * Liste ist, worauf der Rabatt geht – bei VK der gelieferte Preis, bei EK netto die UVP des Herstellers.
 * Weil der Rabatt auch auf die Teuerung gilt, kürzt sie sich heraus: Marge = 1 − (1 − Rabatt) × (1 + Aufschlag),
 * ohne Aufschlag also genau der Rabatt. Bei EK netto ohne Rabatt gibt es keine UVP des Herstellers – dann null.
 */
export function filialMargeProzent(k) {
    if (k.preisart === "ek_netto" && k.rabattProzent === 0)
        return null;
    return (1 - (1 - k.rabattProzent / 100) * (1 + k.aufschlagProzent / 100)) * 100;
}
//# sourceMappingURL=hersteller.js.map